<p-confirmDialog #cd>
    <ng-template #footer>
        <button (click)="cd.onAccept()" class="btn btn-success" type="button">Yes</button>
        <button (click)="cd.onReject()" class="btn btn-basic" type="button">No</button>
    </ng-template>
</p-confirmDialog>

<div cdkDrag [cdkDragDisabled]="!modalDragOn" cdkDragRootElement=".modal-content" class="qrcode-modal">
<!-- <div class="modal-content qrcode-modal"> -->
  <div style="background-color: #548235;  height: 7px;"></div>
  <div class="modal-header" (mouseenter)="setDragOn(true)" (mouseleave)="setDragOn(false)" style="background-color:#a9d18e; height: 50px; padding-top: 20px; border-radius: 0px;">
    <h5 class="modal-title pull-left" style="color: rgb(10, 10, 10); text-transform: none;">Sensor Label</h5>
    <button
        (click)="bsModalRef.hide()"
        class="ms-auto fas fa-times"pe="button"
        style="background-color: transparent; border: transparent; font-size: 16px; margin-top: -4px;;">
    </button>
  </div>
  <br>
  <div id="qrcodeID" class="modal-body text-center qrcenter" style="width: 50%;">
      <!-- <qrcode [qrdata]="QRCode" [size]="64" [level]="'M'" usesvg="true"></qrcode> -->
      <qrcode [qrdata]="QRCode" [width]="80" [errorCorrectionLevel]="'M'" usesvg="true"></qrcode>
      <label style="font-size: 16px; padding-top: 0px; padding-left: 0px; padding-right: 0px;">{{QRLabel}}</label>
  </div>
  <br>
  <div class="text-center">
    <button (click)="downloadPDF('open', 'qrcodeID')" class="btn btn-primary" type="button">Open</button>&nbsp;&nbsp;
    <button (click)="downloadPDF('download', 'qrcodeID')" class="btn btn-primary" type="button">Download</button>
  </div>
  <br>
</div>